import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAppContext } from '../Context';
import { useTranslation } from '../TranslationContext';
import { motion } from 'framer-motion';

const Confirm = () => {
	const { setIsLoading, psServer, submittedCode, paymentGateway, paymentID, gatewayResponse, setPaymentSuccess, setAllowPurchase, allowPurchase } = useAppContext();
	const { t } = useTranslation();
	const navigate = useNavigate();

	useEffect(() => {
		const completeOrder = async () => {
			setIsLoading(true);
			try {
				const response = await fetch(psServer + `/payment/complete`, {
					method: "POST",
					headers: {
						"Content-type": "application/json",
					},
					body: JSON.stringify({
						submittedCode: submittedCode,
						paymentID: paymentID,
						gateway: paymentGateway,
						gatewayResponse: gatewayResponse
					})
				});
				const data = await response.json();
				if (data.status === "COMPLETED") {
					setPaymentSuccess(true);
					setAllowPurchase(false);
					setTimeout(function(){
						navigate('/success');
					}, 1000);
				} else {
					navigate('/failed');
				}
			} catch (error) {
				console.error("Error completing order:", error);
			} finally {
				setIsLoading(false);
			}
		};
		allowPurchase && completeOrder();
	}, [setPaymentSuccess]);
	
	return (
		<div className="paymentMessage">
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.5, ease: "easeInOut" }}
			>
				Please Wait...
			</motion.div>
		</div>
	);
};

export default Confirm;